import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { postTouristsValidateResponseV34 as TouristsValidate } from '@lt/api/dist/methods/tourists/types';
import type { TouristsValidationState } from './types';

export const initialState: TouristsValidationState = {
  fetchStatus: 'NONE',
  isValid: false,
  errors: {
    tourists: [],
    common: [],
  },
};

const touristsValidation = createSlice({
  name: 'touristsValidation',
  initialState,
  reducers: {
    setFetchStatusLoading: (state) => {
      state.fetchStatus = 'LOADING';
    },
    setValidate: (state, action: PayloadAction<TouristsValidate>) => {
      const { errors, valid } = action.payload;

      state.isValid = valid;
      state.fetchStatus = 'LOADED';
      state.errors = {
        tourists: errors?.tourists || [],
        common: errors?.common || [],
      };
    },
    setFetchStatusFailed: (state) => {
      state.fetchStatus = 'FAILED';
    },
  },
});

export const { setFetchStatusLoading, setValidate, setFetchStatusFailed } =
  touristsValidation.actions;

export const { name } = touristsValidation;
export default touristsValidation.reducer;
